import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[commaSeparatedWithTwoDecimal]',
  providers: [DecimalPipe],
})
export class CommaSeparatedWithTwoDecimalsDirective implements OnInit {
  inputElement: HTMLInputElement;
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste',
  ];

  private regex = /^[,.0-9]*$/g;

  constructor(
    private el: ElementRef,
    private model: NgControl,
    private decimal: DecimalPipe
  ) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): any {
    if (
      this.navigationKeys.indexOf(e.key) > -1 || // navigation keys
      ((e.key === 'a' || e.code === 'KeyA') && (e.ctrlKey || e.metaKey)) ||
      ((e.key === 'c' || e.code === 'KeyC') && (e.ctrlKey || e.metaKey)) ||
      ((e.key === 'v' || e.code === 'KeyV') && (e.ctrlKey || e.metaKey)) ||
      ((e.key === 'x' || e.code === 'KeyX') && (e.ctrlKey || e.metaKey))
    ) {
      return;
    }

    const newValue = this.forecastValue(e.key);

    if (!newValue.toString().match(this.regex)) {
      e.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onEvent() {
    const value = this.el.nativeElement.value;
    const transformed = this.transform(value);

    // Only update if the value actually changes to avoid cursor jumping
    if (this.model.value !== transformed) {
      this.model.control.setValue(transformed, { emitEvent: true });
    }
  }

  ngOnInit() {
    const value = this.el.nativeElement.value;
    if (value.toString().match(this.regex)) {
      this.model.control.setValue(this.transform(value), { emitEvent: true });
    }
  }

  private transform(value: any) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const parts = value.toString().split('.');
    let integerPart = (parts[0] as string).replace(/,/g, '');
    if (integerPart === '') {
      integerPart = '0';
    }
    parts[0] = this.decimal.transform(integerPart.substring(0, 14));

    if (parts.length > 1) {
      const decimals = parts[1].toString().substring(0, 2);
      return `${parts[0]}.${decimals}`;
    }

    return parts[0];
  }

  private forecastValue(key: string): string {
    const selectionStart = this.inputElement.selectionStart ?? 0;
    const selectionEnd = this.inputElement.selectionEnd ?? 0;
    const oldValue = this.inputElement.value;
    return (
      oldValue.substring(0, selectionStart) +
      key +
      oldValue.substring(selectionEnd)
    );
  }
}
